
import { useEffect } from "react";
import { motion } from "framer-motion";
import { RotateCcw, Clock, CheckCircle } from "lucide-react";

export default function ReturnsPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Returns & Cancellations</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p>
                We want you to be completely satisfied with your purchase. If you're not happy with your
                order, we offer easy returns and exchanges.
              </p>
              <div className="grid md:grid-cols-3 gap-6 my-8">
                <div className="bg-green-50 rounded-lg p-6">
                  <RotateCcw className="w-8 h-8 text-green-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Easy Returns</h3>
                  <p className="text-sm">7-day return policy</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6">
                  <Clock className="w-8 h-8 text-blue-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Quick Exchanges</h3>
                  <p className="text-sm">Exchange within 7 days</p>
                </div>
                <div className="bg-aarsa-sage-50 rounded-lg p-6">
                  <CheckCircle className="w-8 h-8 text-aarsa-sage-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Full Refund</h3>
                  <p className="text-sm">100% money back guarantee</p>
                </div>
              </div>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Return Policy</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Items must be returned within 7 days of delivery</li>
                <li>Products must be unused, unworn, and in original packaging</li>
                <li>All tags and certificates must be attached</li>
                <li>Customized or personalized items cannot be returned</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">How to Return</h2>
              <ol className="list-decimal list-inside space-y-2">
                <li>Contact our customer service team to initiate a return</li>
                <li>We'll provide you with a return authorization number</li>
                <li>Pack the item securely in its original packaging</li>
                <li>Ship the item back to us using the provided return label</li>
                <li>Once received, we'll process your refund within 5-7 business days</li>
              </ol>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Cancellation Policy</h2>
              <p>
                You can cancel your order within 24 hours of placing it. After 24 hours, orders cannot
                be cancelled but can be returned as per our return policy.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Refund Processing</h2>
              <p>
                Refunds will be processed to the original payment method within 5-7 business days after
                we receive the returned item.
              </p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
